/* Surcharges des skins liées à l'affichage RTL */
import {IEndPoint} from "lib/commons/io/io";
import {IReg} from "lib/commons/registry";

let rootLoaded = false;

/**  Point d'entrée de loading : fronts */
export async function initReg(reg: IReg<any>) {
	await xInitReg(reg);
	rootLoaded = true;
}

/**  Point d'entrée de loading : wed */
export async function jslibAsyncInit(jsEndPoint: IEndPoint, elt: Element, reg: IReg<any>) {
	if (!rootLoaded)
		await xInitReg(reg);
}

async function xInitReg(reg: IReg<any>) {
	await Promise.all([
		await import("skin/modeling/rtl/commonsRTL.js"),
		await import("skin/modeling/rtl/coreRTL.js"),
		await import("skin/modeling/rtl/editRTL.js"),
		await import("skin/modeling/rtl/modelingRTL.js"),
		await import("skin/modeling/rtl/saasRTL.js"),
		await import("skin/modeling/rtl/storeRTL.js"),
		await import("skin/modeling/rtl/wspRTL.js"),
	].map((mod) => {
		mod.ovrReg(reg);
	}));
}



